import React, { Component } from 'react';
import Banner from './Banner';
import OurProducts from '../Products/OurProducts';
import { Row, Col, Container, Image } from 'react-bootstrap';
import './Home.css';
import howitworks from './../../_assets/images/howitworks.png';

class Home extends Component {
    render() {
        return (
            <div>
                <Row>
                    <Banner />
                </Row>
                <Container>
                    <Row className="homecounter-row">
                        <Col md={4} className="text-center">
                            <p className="homeCounter">55%</p>
                            <p className="counterSubText">more energy*</p>
                            <p className="counterConText">for greater savings</p>
                        </Col>
                        <div className="vertical-line" />
                        <Col md={4} className="text-center">
                            <p className="homeCounter">#1</p>
                            <p className="counterSubText">in durability*</p>
                            <p className="counterConText">for peace of mind</p>
                        </Col>
                        <div className="vertical-line" />
                        <Col md={4} className="text-center">
                            <p className="homeCounter">10 Year</p>
                            <p className="counterSubText">industry leading</p>

                            <p className="counterConText">complete system warranty*</p>
                        </Col>
                    </Row>
                </Container>
                <br/>
                <Container>
                    <Row>
                        <Col md={6} className="col6-border">
                            <h3>How it Works</h3>
                          
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> biomass Solar power and basic sciences.</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> eco psychology and manufacturing solar panels.</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> Research in saving power of science & technology.</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> Connections made easy to increase solar energy.</p>
                        </Col>
                        <Col md={6}>
                            <Image src={howitworks} className="img img-responsive" alt="How it Works" />
                        </Col>
                    </Row>
                </Container>
                <OurProducts />
                <Row><br /></Row>
            </div>
        )
    }
}

export default Home;